import { Send } from 'lucide-react';
import ChatBindingCard, { type ChatBindingStatus } from './ChatBindingCard';
import { orgTgApi, type OrgTgStatus } from '../api/tg';

interface Props { orgId: string }

/** Telegram-чат: тонкая обёртка над ChatBindingCard. */
export default function OrgTgChatCard({ orgId }: Props) {
  const adapt = (s: OrgTgStatus): ChatBindingStatus => ({
    enabled: !!s.bot_username,
    linked: !!s.chat,
    chat_id: s.chat?.chat_id || null,
    bot_username: s.bot_username,
    pending_code: s.pending?.code || null,
    pending_expires_at: s.pending?.expires_at || null,
  });
  return (
    <ChatBindingCard
      title="Telegram-чат"
      channel="tg"
      icon={<Send size={11} />}
      accentClass="text-sky-400"
      buttonClass="bg-sky-600 hover:bg-sky-500"
      startCommandUrlPrefix="https://t.me/"
      api={{
        status: () => orgTgApi.status(orgId).then(adapt),
        link: () => orgTgApi.link(orgId).then(() => {}),
        unlink: () => orgTgApi.unlink(orgId).then(() => {}),
      }}
    />
  );
}
